import { makeValuesPredicate } from '@sgme/fp';

export type TradesOrProductsBlotterType = Exclude<
  FilterBlotterType | PreferenceBlotterType,
  'dlpProducts' | 'dlpProductTrades'
>;

export const ALL_TRADE_BLOTTER_TYPES = ['products', 'dlpProducts', 'trades', 'dlpProductTrades'] as const;
export type BlotterType = (typeof ALL_TRADE_BLOTTER_TYPES)[number];
export const NO_MASTER_DETAILS_BLOTTER_TYPES = ['products', 'dlpProducts', 'trades'] as const;
export type NoMasterDetailsBlotterType = (typeof NO_MASTER_DETAILS_BLOTTER_TYPES)[number];
export const isNotMasterDetailBlotterType = makeValuesPredicate(NO_MASTER_DETAILS_BLOTTER_TYPES);

export const MASTER_DETAILS_BLOTTER_TYPES = ['dlpProductTrades'] as const;
export type MasterDetailsBlotterType = (typeof MASTER_DETAILS_BLOTTER_TYPES)[number];
export const isMasterDetailBlotterType = makeValuesPredicate(MASTER_DETAILS_BLOTTER_TYPES);
export const PREFERENCE_BLOTTER_TYPES = ALL_TRADE_BLOTTER_TYPES;

export const PAGE_FILTER_OR_PREFERENCE_BLOTTER_TYPES = ['products', 'dlpProducts', 'trades'] as const;

export const isPageFilterOrPreferenceBlotterType = makeValuesPredicate(PAGE_FILTER_OR_PREFERENCE_BLOTTER_TYPES);
export type FilterBlotterType = (typeof PAGE_FILTER_OR_PREFERENCE_BLOTTER_TYPES)[number];
export type PreferenceBlotterType = (typeof PREFERENCE_BLOTTER_TYPES)[number];
export type PageBlotterType = (typeof PAGE_FILTER_OR_PREFERENCE_BLOTTER_TYPES)[number];

export const ALL_CLIENT_SIDE_BLOTTER_TYPES = ['dlpProductTrades'] as const;
export type ClientSideBlotterType = (typeof ALL_CLIENT_SIDE_BLOTTER_TYPES)[number];

const ALL_SERVER_SIDE_BLOTTER_TYPES = ['dlpProducts'] as const;
export type ServerSideBlotterType = (typeof ALL_SERVER_SIDE_BLOTTER_TYPES)[number];

export const isClientSideBlotter = makeValuesPredicate(ALL_CLIENT_SIDE_BLOTTER_TYPES);
